export interface CableMetricPillInput {
  hovered: boolean;
  selected: boolean;
  /** View can disable automatic hover/selection details without hiding pinned fields. */
  detailsOnInteraction?: boolean;
  /** Suppresses per-cable metrics wholesale. Outranks hover and selection. */
  metricsHidden: boolean;
  /** Presentation-only suppression, including hover/selection and overview labels. */
  labelsHidden?: boolean;
  isSignalCable: boolean;
  simulating: boolean;

  cableSizeVisible: boolean;
  fusesVisible: boolean;
  cableLengthVisible: boolean;
  cableVdropVisible: boolean;
  cableLabelVisible: boolean;

  fuseRating: number | null;
  /** The fuse lives on a bus/block face, which draws it — not on the cable. */
  fuseOnBar: boolean;
  cableLabel: string;
  commentCount: number;
}

export interface CableMetricPills {
  size: boolean;
  fuse: boolean;
  length: boolean;
  vdrop: boolean;
  label: boolean;
  /** False when the whole midpoint group can be skipped — not simply "any of
   *  the above": a comment alone still renders one. */
  any: boolean;
}

export function resolveCableMetricPills(
  input: CableMetricPillInput,
): CableMetricPills {
  const {
    hovered,
    selected,
    metricsHidden,
    isSignalCable,
    simulating,
    fuseRating,
    fuseOnBar,
    cableLabel,
    commentCount,
  } = input;

  const revealDetails = input.detailsOnInteraction !== false && (hovered || selected);
  const revealed = (flag: boolean) => revealDetails || flag;
  const metricsAllowed = !isSignalCable && !metricsHidden;

  const size = metricsAllowed && revealed(input.cableSizeVisible);
  const fuse =
    metricsAllowed &&
    fuseRating != null &&
    !fuseOnBar &&
    revealed(input.fusesVisible);
  const length = metricsAllowed && revealed(input.cableLengthVisible);
  const vdrop = metricsAllowed && !simulating && revealed(input.cableVdropVisible);
  // Deliberately outside `metricsAllowed` — a label is annotation, not a metric.
  const label = !input.labelsHidden && cableLabel.trim().length > 0 && revealed(input.cableLabelVisible);

  return {
    size,
    fuse,
    length,
    vdrop,
    label,
    any: size || fuse || length || vdrop || label || commentCount > 0,
  };
}
